<template>
  <svg
      xmlns="http://www.w3.org/2000/svg"
      class="actionIcon" viewBox="0 0 20 20"
      fill="currentColor" @click="onClick">
    <path
        d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
        fill-rule="evenodd" clip-rule="evenodd"/>
  </svg>
</template>

<script>

export default {
  name: "CancelIcon",
  methods: {
    onClick() {
      this.$emit("clicked");
    }
  }
};

</script>

<style scoped>
</style>